import { defineMessages } from 'react-intl'

export default defineMessages({
  continue: {
    id: 'eligibilitychecks.continue',
    defaultMessage: `{person, select,
      first {Check my insurance}
      other {Continue}
    }`,
  },
  insuranceProviderPlaceholder: {
    id: 'eligibilitycheck.insuranceproviderplaceholder',
    defaultMessage: `{person, select,
      first {Select your insurance provider}
      other {Select {name}’s insurance provider}
    }`,
  },
  insurancePlanPlaceholder: {
    id: 'eligibilitycheck.insuranceplanplaceholder',
    defaultMessage: `{person, select,
      first {Select your insurance plan}
      other {Select {name}’s insurance plan}
    }`,
  },
  insuranceIdHelpText: {
    id: 'eligibilitychecks.insuranceidhelptext',
    defaultMessage: `{person, select,
      first {Enter your insurance ID exactly as it appears on your insurance or benefits cards. Include any letters, spaces, and dashes}
      other {Enter their insurance ID exactly as it appears on their insurance or benefits cards. Include any letters, spaces, and dashes}
    }`,
  },
  showInsuranceProfileUpdate: {
    id: 'eligibilitycheck.showinsuranceprofileupdate',
    defaultMessage: `{person, select,
      first {Are your insurance ID details as follows?}
      other {Are their insurance ID details as follows?}
    }`,
  },
  yes: {
    id: 'eligibilitycheck.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'eligibilitycheck.no',
    defaultMessage: 'No',
  },
  success: {
    id: 'eligibilitycheck.success',
    defaultMessage: `{person, select,
      first {Your insurance details have been successfully added}
      other {{name}’s insurance details have been successfully added}
    }`,
  },
})
